import { ZipBoxIcon } from './ZipBoxIcon';

/**
 * author: Google
 * id 00A83C35-A726-464B-ACEE-F0D690045C25
 * name zip-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zip-box.svg
 * tags
 * - Files / Folders 
 */
export const CompressedFileIcon = ZipBoxIcon;
export default CompressedFileIcon